// extracted by mini-css-extract-plugin
export default {"item":"AmoCrmToggle_item__QnDOS","icons":"AmoCrmToggle_icons__BMbxL","label":"AmoCrmToggle_label__95dYm"};